import { homeKeys } from '@/features/home/queries/query-keys';
import { fetchAcademyById } from '@/features/home/services';
import { CoachDoc, fetchCoachByUid } from '@/features/home/services/get-coach';
import { WithId } from '@/libs/firebase/firestore';
import { QueryObserverResult, useQuery } from '@tanstack/react-query';

type CoachQueryData = WithId<
  Omit<CoachDoc, 'inactiveFilterLevel'> & { inactiveFilterLevel?: number | null }
>;

export function useCoachQuery(uid?: string): QueryObserverResult<CoachQueryData | null> {
  return useQuery({
    queryKey: homeKeys.coach(uid),
    queryFn: () => fetchCoachByUid(uid as string),
    enabled: Boolean(uid),
    select: (data): CoachQueryData | null => {
      if (!data) return null;
      return {
        ...data,
        inactiveFilterLevel:
          data.inactiveFilterLevel !== null && data.inactiveFilterLevel !== undefined
            ? Number(data.inactiveFilterLevel)
            : undefined,
      };
    },
  });
}

export function useAcademyQuery(academyId?: string | null) {
  return useQuery({
    queryKey: homeKeys.academy(academyId),
    queryFn: () => fetchAcademyById(academyId as string),
    enabled: Boolean(academyId),
  });
}
